import React from "react";

export const PageNotFound: React.FC = () => {
    return (
        <div className="flex justify-center items-center min-h-full">
            <div className="p-12  text-center max-w-md w-[90%] animate-fadeIn">
                <h4 className="text-[4rem] font-sans font-bold text-red-600 mb-4 animate-pulse">
                    404
                </h4>
                <p className="text-3xl font-semibold text-red-500 mb-2">
                    Page Not Found
                </p>
                <p className="text-gray-600 mb-8">Sorry, We can't find this page</p>
            </div>
        </div>
    );
};

